import {
    News1Image1,
    News1Image2,
    News1,
    News2,
    Act2025_Huawei,
    Act2025_Ishtiaque,
    Act2025_AskinIztech,
    Act2025_YingzhuoICC,
    Act2025_AskinKTH1,
    Act2025_AskinEuCNC1,
    Act2025_Eindhoven1,
    Act2025_Sicong,
} from 'assets/images/news'


const news = [
    {
        id: '0',
        title: 'SCION f2f Kick-off Meeting',
        // desc: 'SCION f2f Kick-off Meeting will be organized on 3th April 2023 at Izmir Institute of Technology, İzmir, Türkiye. 10 PhD Positions were announced at https://euraxess.ec.europa.eu/jobs/61298 SCION Virtual Kick-off Meeting was held on Monday, 20 Feb. 2023.',
        desc: 'SCION f2f Kick-off Meeting was held on 3th April 2023 at Izmir Institute of Technology, İzmir, Türkiye.',
        imgUrl: News1Image1,
        link: 'https://euraxess.ec.europa.eu/jobs/61298',
        time: '3 April 2023',
        images: [
            {
                title: 'image1',
                imgUrl: News1Image1
            },
            {
                title: 'image3',
                imgUrl: News1Image2
            },

        ],
    },
    {
        id: '1',
        title: '10 PhD Positions were announced',
        desc: '10 PhD Positions were announced at https://euraxess.ec.europa.eu/jobs/61298',
        imgUrl: 'https://picsum.photos/300/250',
        images: [
            // {
            //     title: 'image1',
            //     imgUrl: 'https://i.pinimg.com/originals/a0/c2/2b/a0c22b34dacb4d2c76bd0fe27f833a2c.jpg'
            // },
            {
                title: 'image3',
                imgUrl: 'https://umit.net/wp-content/uploads/2021/11/rbcxo9au-u-1.jpg'
            },
            {
                title: 'image2',
                imgUrl: 'https://www.gaste24.com/images/album/26_1919.jpg'
            },
        ],
        time: '20 Feb. 2023.',
    },
]

// Yeni haberler için data array
export const featuredNews = [
    {
        id: '1',
        title: "SCION F2F Meeting in HUAWEI-Munich",
        description: 'The SCION Project conducted an F2F meeting in HUAWEI-Munich, Germany, on December 2025. All PhD students presented their results to the consortium.',
        date: 'December 2025',
        imageUrl: Act2025_Huawei,
        person: null,
        category: 'activity'
    },
    {
        id: '2',
        title: "Ishtiaque Ahmed – Secondment at IZTECH",
        description: 'Ishtiaque Ahmed completed 11-weeks secondment (05/09/2025-24/11/2025) at the İzmir Institute of Technology (IZTECH) in İzmir, Turkey, under the supervision of Prof. Berna Özbek, with a particular focus on the deployment of Pinching-Antennas System (PASS) for deployment in a heterogeneous users network and autonomous vehicles communication.',
        date: 'September – November 2025',
        imageUrl: Act2025_Ishtiaque,
        person: null,
        category: 'activity'
    },
    {
        id: '3',
        title: "SCION Workshop at IEEE PIMRC 2025",
        description: 'The evolution of 6G networks through connected Intelligence is poised to revolutionize wireless communication seamlessly by integrating semantic communication for integrated terrestrial and non-terrestrial networks (NTN). The advent of 6G networks is a transformative era characterized by the interaction of autonomous systems, including drones, robots, vehicles, and Internet of Things (IoT) devices...',
        date: 'September 2025',
        imageUrl: News1,
        person: null,
        externalUrl: 'https://pimrc2025.ieee-pimrc.org/workshop/ws-13-semantic-communications-intelligent-and-integrated-terrestrial-and-non-terrestrial',
        category: 'workshop'
    },
    {
        id: '4',
        title: "Askin Altinoklu – Secondment at IZTECH",
        description: 'Askin Altinoklu completed a two-month secondment (03/07/2025–31/08/2025) at the İzmir Institute of Technology (IZTECH) in İzmir, Turkey, under the supervision of Prof. Berna Özbek, with a particular focus on the joint optimization of Age of Information (AoI) and hybrid beamforming using Dynamic Metasurface Antennas (DMAs), addressing energy-efficient and latency-sensitive scheduling strategies under practical hardware constraints in machine-type communication scenarios.',
        date: 'July – August 2025',
        imageUrl: Act2025_AskinIztech,
        person: null,
        category: 'activity'
    },
    {
        id: '5',
        title: "Sicong Ye – Secondment at IRIS Company",
        description: 'Sicong Ye completed a six-month secondment (01/06/2025–30/11/2025) at IRIS Company in Coventry, UK, under the supervision of Dr Faiyaz Doctor, in collaboration with Akshay Mohan Nair.',
        date: 'June – November 2025',
        imageUrl: Act2025_Sicong,
        person: null,
        category: 'activity'
    },
    {
        id: '6',
        title: "Yingzhuo Sun – Oral Presentation at ICC 2025",
        description: 'Yingzhuo Sun will give an oral presentation about the submitted paper at ICC2025 on June 10th.',
        date: 'June 2025',
        imageUrl: Act2025_YingzhuoICC,
        person: null,
        category: 'activity'
    },
    {
        id: '7',
        title: "Askin Altinoklu – Paper Presentation at EuCNC & 6G Summit 2025",
        description: 'Askin Altinoklu presented his paper at the 2025 EuCNC & 6G Summit in Poznań, Poland, titled "Investigation of Holographic Beamforming via Dynamic Metasurface Antennas in QoS-Guaranteed, Power-Efficient Networks." (02/06/2025-06/06/2025)',
        date: 'June 2025',
        imageUrl: Act2025_AskinEuCNC1,
        person: null,
        category: 'activity'
    },
    {
        id: '8',
        title: "Askin Altinoklu – Secondment at KTH Royal Institute of Technology",
        description: 'Askin Altinoklu completed a two-month of secondment (06/04/2025-30/05/2025) at KTH Royal Institute of Technology in Stockholm, Sweden, under the supervision of Prof. Ming Xiao, with a particular focus on hybrid beamforming architectures utilizing dynamic metasurface antennas (DMAs), ultra-wideband near-field communication, path-based beamforming via Delay Alignment Modulation (DAM), and energy-efficient transmission strategies.',
        date: 'April – May 2025',
        imageUrl: Act2025_AskinKTH1,
        person: null,
        category: 'activity'
    },
    {
        id: '9',
        title: "SCION F2F Meeting in Eindhoven",
        description: 'The SCION Project conducted an F2F meeting in Eindhoven University-Netherlands, on March 2025. All PhD students attended training activities and prepared posters related to their PhD thesis.',
        date: 'March 2025',
        imageUrl: Act2025_Eindhoven1,
        person: null,
        category: 'activity'
    },
    {
        id: '10',
        title: "SCION Leaflet & Call for Papers",
        description: 'Download our comprehensive leaflet and call for papers documentation.',
        date: 'Available Now',
        imageUrl: News2,
        person: null,
        downloadUrl: '/SCION_1st_Leaflet.pdf',
        category: 'documents'
    }
]

// export const lastNews = [
//     {
//         id: '0',
//         title: 'SCION f2f Kick-off Meeting',
//         // desc: 'SCION f2f Kick-off Meeting will be organized on 3th April 2023 at Izmir Institute of Technology, İzmir, Türkiye. 10 PhD Positions were announced at https://euraxess.ec.europa.eu/jobs/61298 SCION Virtual Kick-off Meeting was held on Monday, 20 Feb. 2023.',
//         desc: 'SCION f2f Kick-off Meeting was held on 3th April 2023 at Izmir Institute of Technology, İzmir, Türkiye.',
//         imgUrl: News1Image1,
//         link: 'https://euraxess.ec.europa.eu/jobs/61298',
//         time: '3 April 2023',
//         images: [
//             {
//                 title: 'image1',
//                 imgUrl: News1Image1
//             },
//             {
//                 title: 'image3',
//                 imgUrl: News1Image2
//             },

//         ],
//     },
//     // {
//     //     id: '1',
//     //     title: '10 PhD Positions were announced',
//     //     desc: '10 PhD Positions were announced at https://euraxess.ec.europa.eu/jobs/61298 SCION Kick-off Meeting was held on Monday, 20 Feb. 2023.',
//     //     imgUrl: 'https://picsum.photos/300/250',
//     //     images: [
//     //         // {
//     //         //     title: 'image1',
//     //         //     imgUrl: 'https://i.pinimg.com/originals/a0/c2/2b/a0c22b34dacb4d2c76bd0fe27f833a2c.jpg'
//     //         // },
//     //         {
//     //             title: 'image3',
//     //             imgUrl: 'https://umit.net/wp-content/uploads/2021/11/rbcxo9au-u-1.jpg'
//     //         },
//     //         {
//     //             title: 'image2',
//     //             imgUrl: 'https://www.gaste24.com/images/album/26_1919.jpg'
//     //         },
//     //     ],
//     //     time: '20 Feb. 2023.',
//     // },
// ]

export default news